module.exports = __webpack_public_path__ + "media/wood-duck-2.93df30d2.mp3";